/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown>, comment: NonNullable<unknown> }} Timeline_Marker_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Marker at {timecode} - {comment}" |
*
* @param {Timeline_Marker_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_marker_aria_label = /** @type {((inputs: Timeline_Marker_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Marker_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Marqueur a ${i?.timecode} - ${i?.comment}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Markierung bei ${i?.timecode} - ${i?.comment}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Marcatore a ${i?.timecode} - ${i?.comment}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Маркер на ${i?.timecode} - ${i?.comment}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Marcador en ${i?.timecode} - ${i?.comment}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`标记点位于 ${i?.timecode} - ${i?.comment}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.timecode} - ${i?.comment} のマーカー`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`मार्कर ${i?.timecode} - ${i?.comment} पर`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Marcador em ${i?.timecode} - ${i?.comment}`)
	return /** @type {LocalizedString} */ (`Marker at ${i?.timecode} - ${i?.comment}`)
});